import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import reducer from './store/reducer/index.reducer';
import {Provider} from "react-redux";
import {configure} from "@testing-library/react";
import configureStore from './store/index.store';
import {BrowserRouter} from "react-router-dom";


const store = configureStore(reducer);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
  </Provider>
);
